import React from "react";
import { Button, Image, Space, Table, Tag, Tooltip, Typography } from "antd";
import { CopyOutlined, DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import FileTypeIcon from "./FileTypeIcon";
import {
  formatDate,
  formatFileSize,
  getParseDashboardUrl,
  isImage,
} from "./allegatiUtils";
import ParseLogo from "../../../shared/images/parse.png";

const { Text } = Typography;

const AllegatiTable = ({ items, isProd, onFileAction }) => {
  const columns = [
    {
      title: "Nome",
      dataIndex: "nome",
      key: "nome",
      render: (text, record) => {
        const fileUrl = record.allegato?.url;

        return (
          <Space>
            {isImage(record.mimeType) && fileUrl ? (
              <div
                style={{
                  width: 40,
                  height: 40,
                  border: "1px solid #f0f0f0",
                  borderRadius: "4px",
                  overflow: "hidden",
                  background:
                    "repeating-conic-gradient(#f0f0f0 0% 25%, transparent 0% 50%) 50% / 10px 10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={40}
                  height={40}
                  src={fileUrl}
                  preview={false}
                  style={{
                    objectFit: "cover",
                    cursor: "pointer",
                    display: "block",
                  }}
                  onClick={() => onFileAction(record, "view")}
                />
              </div>
            ) : (
              <FileTypeIcon mimeType={record.mimeType} />
            )}
            <Text>{text || "Senza nome"}</Text>
          </Space>
        );
      },
    },
    {
      title: "Tipo",
      dataIndex: "mimeType",
      key: "mimeType",
      width: 150,
      render: (mimeType) => mimeType || "-",
    },
    {
      title: "Dimensione",
      dataIndex: "size_bytes",
      key: "size_bytes",
      width: 120,
      render: (size) => formatFileSize(size),
    },
    {
      title: "Defunto",
      dataIndex: ["defunto_pointer", "nome"],
      key: "defunto",
      width: 200,
      render: (nome, record) => {
        const cognome = record.defunto_pointer?.cognome;
        if (nome || cognome) {
          return `${nome || ""} ${cognome || ""}`.trim();
        }
        return "-";
      },
    },
    {
      title: "Condiviso",
      dataIndex: "condiviso",
      key: "condiviso",
      width: 100,
      render: (condiviso) => (
        <Tag color={condiviso ? "green" : "default"}>{condiviso ? "Sì" : "No"}</Tag>
      ),
    },
    {
      title: "Creato il",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      render: (date) => formatDate(date),
    },
    {
      title: "Azioni",
      key: "actions",
      width: 180,
      render: (_, record) => (
        <Space size="small">
          {record.allegato?.url && (
            <>
              <Tooltip title="Visualizza">
                <Button
                  type="link"
                  icon={<EyeOutlined />}
                  onClick={() => onFileAction(record, "view")}
                />
              </Tooltip>
              <Tooltip title="Copia URL">
                <Button
                  type="link"
                  icon={<CopyOutlined />}
                  onClick={() => onFileAction(record, "copy")}
                />
              </Tooltip>
              <Tooltip title="Scarica">
                <Button
                  type="link"
                  icon={<DownloadOutlined />}
                  onClick={() => onFileAction(record, "download")}
                />
              </Tooltip>
            </>
          )}
          <Tooltip title="Apri in Parse Dashboard">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={getParseDashboardUrl(record.objectId, isProd)}
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <img src={ParseLogo} width={16} alt="Parse Dashboard" />
            </a>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={items}
      columns={columns}
      rowKey={(record) => record.objectId}
      pagination={false}
      size="middle"
      scroll={{ x: 1000 }}
    />
  );
};

export default AllegatiTable;
